module.exports = __webpack_public_path__ + "static/media/Screenshot_2.49da966b.png";